import { render, staticRenderFns } from "./CollectionCategoryLinks.vue?vue&type=template&id=bf565ad6&scoped=true&lang=pug&"
import script from "./CollectionCategoryLinks.vue?vue&type=script&lang=js&"
export * from "./CollectionCategoryLinks.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCategoryLinks.vue?vue&type=style&index=0&id=bf565ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf565ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf565ad6')) {
      api.createRecord('bf565ad6', component.options)
    } else {
      api.reload('bf565ad6', component.options)
    }
    module.hot.accept("./CollectionCategoryLinks.vue?vue&type=template&id=bf565ad6&scoped=true&lang=pug&", function () {
      api.rerender('bf565ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionCategoryLinks.vue"
export default component.exports